/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Route } from 'react-router-dom';
import colors from '../../styles/colors';
import * as Intercom from '../../util/Intercom';

const GlobalStyle = createGlobalStyle`
  body {
    background: #FAFAFA !important;
  }
`;

const LayoutContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: ${colors.background};
  body {
    background-color: "#FAFAFA" !important;
  }
  ${(p) => p.centered && `
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    align-items: center;
    justify-content: center;
  `}
`;

export default function AuthLayout({
  history, component: Component, centered = true, ...rest
}) {
  Intercom.boot({}, {}, false);

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <LayoutContainer centered={centered}>
          <GlobalStyle />
          <Component {...matchProps} />
        </LayoutContainer>
      )}
    />
  );
}
